export default __webpack_public_path__ + "26f91d9ab1bffd02f6187223c2858270.png";